import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { authApi } from '../services';

export interface AttemptState {
  value: { [user: string]: number };
  activeUser: string | null;
}

const initialState: AttemptState = { value: {}, activeUser: null };

export const attemptSlice = createSlice({
  name: 'attempt',
  initialState,
  reducers: {
    attemptLogin: (state, action: PayloadAction<string>) => {
      state.activeUser = action.payload;
      const actualAttempt = state.value[action.payload] || 1;
      state.value[action.payload] = actualAttempt + 1;
    },
  },
  extraReducers: builder => {
    builder
      .addMatcher(authApi.endpoints.logout.matchFulfilled, (state, action) => {
        const { responseCode } = action.payload.result;
        if (responseCode === 200) {
          const {
            user: { username },
          } = action.payload;
          state.value[username] = 0;
        }
      })
      /**
       * Con Java, un login fallido igual llegaba como `matchFulfilled` (200
       * con el rechazo dentro de `result`), así que hacía falta comprobar
       * `responseCode === 200` antes de resetear el contador. NestJS rechaza
       * la promesa cuando el login falla — `matchFulfilled` ya significa
       * éxito, sin nada que comprobar.
       */
      .addMatcher(authApi.endpoints.login.matchFulfilled, (state, action) => {
        const {
          user: { username },
        } = action.payload;
        state.value[username] = 0;
      });
  },
});

export const { attemptLogin } = attemptSlice.actions;

export const attemptReducer = attemptSlice.reducer;
